import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { hrmsGetRequest, hrmsPostRequest, hrmsUpdateRequest, hrmsDeleteRequest } from "../services/index";

const API_URL = "/api/designations";

// Fetch Designations
export const fetchDesignations = createAsyncThunk("designations/fetch", async () => {
  const response = await hrmsGetRequest(API_URL);
  return response.data;
});

// Add Designation
export const addDesignation = createAsyncThunk("designations/add", async (designationData) => {
  const response = await hrmsPostRequest(API_URL, designationData);
  return response.data;
});

// Update Designation
export const updateDesignation = createAsyncThunk("designations/update", async ({ id, updatedData }) => {
  const response = await hrmsUpdateRequest(`${API_URL}/${id}`, updatedData);
  return response.data;
});

// Delete Designation
export const deleteDesignation = createAsyncThunk("designations/delete", async (id) => {
  await hrmsDeleteRequest(`${API_URL}/${id}`);
  return id;
});

// Update Designation Status
export const updateDesignationStatus = createAsyncThunk("designations/updateStatus", async ({ id, status }) => {
  const response = await hrmsUpdateRequest(`${API_URL}/${id}/status`, { status });
  return response.data;
});

const designationSlice = createSlice({
  name: "designations",
  initialState: {
    designations: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDesignations.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchDesignations.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.designations = action.payload;
      })
      .addCase(fetchDesignations.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(addDesignation.fulfilled, (state, action) => {
        state.designations.push(action.payload);
      })
      .addCase(updateDesignation.fulfilled, (state, action) => {
        const index = state.designations.findIndex((desig) => desig.id === action.payload.id);
        if (index !== -1) {
          state.designations[index] = action.payload;
        }
      })
      .addCase(deleteDesignation.fulfilled, (state, action) => {
        state.designations = state.designations.filter((desig) => desig.id !== action.payload);
      })
      .addCase(updateDesignationStatus.fulfilled, (state, action) => {
        const index = state.designations.findIndex((desig) => desig.id === action.payload.id);
        if (index !== -1) {
          state.designations[index] = action.payload;
        }
      });
  },
});

export default designationSlice.reducer;